import React, { useEffect, useState } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { getFormValues } from "redux-form";

import Content from "../common/template/content";
import ContentCard from "../common/template/contentCard";
import ContentCardHeader from "../common/template/contentCardHeader";
import ContentCardFooter from "../common/template/contentCardFooter";
import ContentCardBody from "../common/template/contentCardBody";
import Row from "../common/layout/row";
import Grid from "../common/layout/grid";
import Table from "../common/table/table";
import THead from "../common/table/tHead";
import NewTr from "../common/table/newTr";
import Th from "../common/table/th";
import TBody from "../common/table/tBody";
import Td from "../common/table/td";
import ButtonTable from "../common/table/buttonTable";
import Button from "../common/button/button";
import Form from "./demandaContratoForm";
import FormAgendamento from "./demandaAgendamentoForm";
import Select from "../common/form/select";
import { DisplayPDF } from "../displayPDF/displayPDF";
import { Loading } from "../common/loading/loading";
import LabelAndCheckbox from "../common/form/labelAndCheckbox";

import {
    setModoTela,
    initForm,
    setFiltro,
    salvar,
    excluir,
    salvarAgendamento,
    excluirAgendamento,
    getLista,
    getListaCliente,
    getListaUnidadeConsumidora,
    getListaDemandaContratoTipo,
    importarContrato,
    importarCusd,
    importarCcer,
    importarCicloRural,
    buscaContrato,
    buscaCusd,
    buscaCcer,
    buscaCicloRural,
    encerrar,
    reabrir,
} from "./demandaContratoActions";

import { setArquivoPDF } from "../displayPDF/displayPDFActions";
import { ModalHistoricoDemandas } from "../analise/components/ModalHistoricoDemandas";
import { ModalGestorConcessonaria } from "../analise/components/ModalGestorConcessionaria";
import { LabelSelectUcIconeGestor } from "../common/form/LabelSelectUcIconeGestor";

function DemandaContrato(props) {
    const [state, setState] = useState({
        descricao: null,
        file: null,
        arquivo_cusd: null,
        filtro: { tipo_sazonalidade: 1 },
        exibirModalHistorico: false,
        exibirModalGestorConcessionaria: false,
        itemSelecionado: null,
    });

    //Sem acesso
    if (!props.usuarioLogado || props.usuarioLogado.acesso_cliente) {
        return <div />;
    }
    useEffect(() => {
        props.getListaCliente();
        props.getListaUnidadeConsumidora();
        props.getListaDemandaContratoTipo();
        props.getLista();
    }, []);

    useEffect(() => {
        props.getLista();
    }, [props.filtro]);

    if (props.pdf) {
        return <DisplayPDF closePdf={() => props.setArquivoPDF()} pdfBase64={props.pdf} nomePdf={props.nomePdf} />;
    }
    return (
        <div>
            {props.aguardando ? <Loading /> : null}
            <ModalHistoricoDemandas
                contratoDemanda={state.itemSelecionado}
                visible={state.exibirModalHistorico && state.itemSelecionado && !props.pdf}
                handleClose={() => setState({ ...state, exibirModalHistorico: false, itemSelecionado: null })}
            />
            <ModalGestorConcessonaria
                visible={state.exibirModalGestorConcessionaria && state.itemSelecionado && state.itemSelecionado.gestor_concessionaria_energia}
                itemSelecionado={state.itemSelecionado}
                handleClose={() => setState({ ...state, exibirModalGestorConcessionaria: false, itemSelecionado: null })}
            />
            <Content>
                {props.modoTela === "visualizacao" ? <Form visualizar onSubmit={() => {}} /> : null}
                {props.modoTela === "cadastro" ? <Form onSubmit={props.salvar} /> : null}
                {props.modoTela === "importarContrato" ? importarContrato() : null}
                {props.modoTela === "importarCusd" ? importarCusd() : null}
                {props.modoTela === "importarCcer" ? importarCcer() : null}
                {props.modoTela === "importarCicloRural" ? importarCicloRural() : null}
                {props.modoTela === "cadastroAgendamento" ? <FormAgendamento onSubmit={props.salvarAgendamento} /> : null}
                {props.modoTela === "exclusaoAgendamento" ? <FormAgendamento excluir onSubmit={props.excluirAgendamento} /> : null}
                {props.modoTela === "exclusao" ? <Form excluir onSubmit={props.excluir} /> : null}
                {props.modoTela === "lista" ? lista() : null}
            </Content>
        </div>
    );

    function lista() {
        return (
            <ContentCard>
                <ContentCardHeader>
                    <Row>
                        <Grid cols="12 6 6 3">
                            <Button
                                text="Adicionar Contrato Sazonal"
                                type={"success"}
                                icon={"fa fa-plus"}
                                disabled={!props.usuarioLogado.acesso_cadastro_demanda_adicionar}
                                event={() => {
                                    props.setModoTela("cadastro", {});
                                    props.initForm({
                                        sazonal: true,
                                        encerrado: false,
                                        competencia_base_sazonalidade: null,
                                    });
                                }}
                            />
                        </Grid>
                        <Grid cols="12 6 6 3">
                            <Button
                                text="Adicionar Contrato Não Sazonal"
                                type={"success"}
                                icon={"fa fa-plus"}
                                disabled={!props.usuarioLogado.acesso_cadastro_demanda_adicionar}
                                event={() => {
                                    props.setModoTela("cadastro", {});
                                    props.initForm({
                                        sazonal: false,
                                        encerrado: false,
                                        competencia_base_sazonalidade: null,
                                        mes_inicio: 1,
                                        mes_fim: 12,
                                    });
                                }}
                            />
                        </Grid>
                    </Row>
                </ContentCardHeader>
                <ContentCardBody>
                    <Row style={{ paddingBlock: 30 }}>
                        <Select
                            name="id_cliente"
                            options={props.listaCliente}
                            label="Cliente"
                            cols="12 6 3"
                            placeholder="Selecione o Cliente"
                            value={props.filtro.id_cliente}
                            onChange={(value) => {
                                props.setFiltro({
                                    ...props.filtro,
                                    id_cliente: value,
                                });
                            }}
                        />

                        <Select
                            name="id_unidade_consumidora"
                            options={props.listaUnidadeConsumidora.filter((item) => {
                                const condicaoCliente = !props.filtro.id_cliente || item.id_cliente == props.filtro.id_cliente;
                                const condicaoContrato = props.lista.find((contrato) => contrato.id_unidade_consumidora == item.id);
                                return condicaoCliente && condicaoContrato;
                            })}
                            label={
                                <LabelSelectUcIconeGestor
                                    filtro={props.filtro}
                                    listaUnidadeConsumidora={props.listaUnidadeConsumidora}
                                    setExibirModal={(ucFiltro) =>
                                        setState({
                                            ...state,
                                            exibirModalGestorConcessionaria: true,
                                            itemSelecionado: ucFiltro,
                                        })
                                    }
                                />
                            }
                            cols="12 6 3"
                            placeholder="Selecione a UC"
                            value={props.filtro.id_unidade_consumidora}
                            onChange={(value) => {
                                props.setFiltro({
                                    ...props.filtro,
                                    id_unidade_consumidora: value,
                                });
                            }}
                        />

                        <Select
                            name="tipo_sazonalidade"
                            options={[
                                { id: 1, valor: "Todos" },
                                { id: 2, valor: "Sazonal" },
                                { id: 3, valor: "Não Sazonal" },
                            ]}
                            label="Tipo Sazonalidade do Contrato"
                            cols="12 6 3"
                            placeholder="Selecione o tipo"
                            isClearable={false}
                            isSearchable={false}
                            value={state.filtro.tipo_sazonalidade}
                            onChange={(value) => {
                                setState({
                                    ...state,
                                    filtro: {
                                        ...state.filtro,
                                        tipo_sazonalidade: value,
                                    },
                                });
                            }}
                        />
                        <LabelAndCheckbox
                            cols="12 6 3"
                            style={{
                                backgroundColor: "#e83030",
                                width: "100%",
                                color: "#FFF",
                                padding: "8px 10px",
                                borderRadius: "0.3rem",
                                marginTop: window.innerWidth > 768 ? 28 : 0,
                                justifyContent: "center",
                            }}
                            readOnly={props.aguardando}
                            modoCard={true}
                            colorIcon="#FFF"
                            label={`Somente Contratos Encerrados`}
                            onChange={(e) => {
                                props.setFiltro({
                                    ...props.filtro,
                                    encerrado: !props.filtro.encerrado,
                                });
                            }}
                            value={!!props.filtro.encerrado}
                        />
                    </Row>

                    <Table responsive maxHeight="65vh">
                        <THead>
                            <NewTr backgroundColorTr={"#FFFFFF"} backgroundColorTd={"#F5F5F5"}>
                                <Th sticky colSpan={1}>
                                    Período
                                </Th>
                                <Th sticky colSpan={1}>
                                    Cliente
                                </Th>
                                <Th sticky colSpan={1}>
                                    UC
                                </Th>
                                <Th sticky colSpan={1}>
                                    Tipo de Sazonalidade
                                </Th>
                                <Th sticky colSpan={1}>
                                    Aviso
                                </Th>
                                <Th sticky colSpan={1} alignCenter>
                                    Contrato CUSD
                                </Th>
                                <Th sticky colSpan={1} alignCenter>
                                    Contrato CCER
                                </Th>
                                <Th sticky colSpan={1} alignCenter>
                                    Ciclo Sazonal
                                </Th>
                                <Th sticky>Histórico</Th>
                            </NewTr>
                        </THead>
                        <TBody>
                            {props.lista
                                .filter((item) => {
                                    const condicaoEncerrado = props.filtro.encerrado ? item.encerrado : !item.encerrado;
                                    const condicaoTipoSazonalidade =
                                        state.filtro.tipo_sazonalidade == 1 ||
                                        (state.filtro.tipo_sazonalidade == 2 && item.sazonal) ||
                                        (state.filtro.tipo_sazonalidade == 3 && !item.sazonal);
                                    return condicaoEncerrado && condicaoTipoSazonalidade;
                                })
                                .map((item) => {
                                    const botoes = [];
                                    let botoesDirectionRow = false;
                                    const competencia_base_sazonalidade = item.competencia_base_sazonalidade
                                        ? `${String(item.competencia_base_sazonalidade).substring(4, 6)}/${String(item.competencia_base_sazonalidade).substring(0, 4)}`
                                        : null;
                                    //se os 2 tiver sazonal ou os 2 tiver não sazonal mostra os botoes de editar e excluir
                                    if (item.unidade_consumidora_sazonal == item.sazonal && !item.encerrado) {
                                        botoes.push(
                                            {
                                                type: "primary",
                                                icon: "fas fa-eye",
                                                disabled: !props.usuarioLogado.acesso_cadastro_demanda_visualizar,
                                                event: () => {
                                                    //cria a lista de valores valor_1 ..... valor_12 e adiciona ao registro
                                                    const valores = {};
                                                    for (let i = 1; i <= 12; i++) {
                                                        valores[`valor_${i}`] = parseFloat(item[`valor_${i}`]) > 0 ? parseFloat(item[`valor_${i}`]) : null;
                                                        valores[`valor_${i}_ponta`] = parseFloat(item[`valor_${i}_ponta`]) > 0 ? parseFloat(item[`valor_${i}_ponta`]) : null;
                                                        valores[`valor_${i}_geracao`] = parseFloat(item[`valor_${i}_geracao`]) > 0 ? parseFloat(item[`valor_${i}_geracao`]) : null;
                                                    }
                                                    const registro = {
                                                        ...item,
                                                        ...valores,
                                                        competencia_base_sazonalidade,
                                                    };
                                                    props.setModoTela("visualizacao", registro);
                                                    props.initForm(registro);
                                                },
                                            },
                                            {
                                                type: "warning",
                                                icon: "fas fa-pencil-alt",
                                                disabled: !props.usuarioLogado.acesso_cadastro_demanda_editar || item.bloquearEdicaoUsuarioImplantacao,
                                                event: () => {
                                                    //cria a lista de valores valor_1 ..... valor_12 e adiciona ao registro
                                                    const valores = {};
                                                    for (let i = 1; i <= 12; i++) {
                                                        valores[`valor_${i}`] = parseFloat(item[`valor_${i}`]) > 0 ? parseFloat(item[`valor_${i}`]) : null;
                                                        valores[`valor_${i}_ponta`] = parseFloat(item[`valor_${i}_ponta`]) > 0 ? parseFloat(item[`valor_${i}_ponta`]) : null;
                                                        valores[`valor_${i}_geracao`] = parseFloat(item[`valor_${i}_geracao`]) > 0 ? parseFloat(item[`valor_${i}_geracao`]) : null;
                                                    }
                                                    const registro = {
                                                        ...item,
                                                        ...valores,
                                                        competencia_base_sazonalidade,
                                                    };

                                                    props.setModoTela("cadastro", registro);
                                                    props.initForm(registro);
                                                },
                                            },

                                            {
                                                type: "danger",
                                                icon: "fas fa-trash-alt",
                                                disabled: !props.usuarioLogado.acesso_cadastro_demanda_excluir || item.bloquearEdicaoUsuarioImplantacao,
                                                event: () => {
                                                    //cria a lista de valores valor_1 ..... valor_12 e adiciona ao registro
                                                    const valores = {};
                                                    for (let i = 1; i <= 12; i++) {
                                                        valores[`valor_${i}`] = parseFloat(item[`valor_${i}`]) > 0 ? parseFloat(item[`valor_${i}`]) : null;
                                                        valores[`valor_${i}_ponta`] = parseFloat(item[`valor_${i}_ponta`]) > 0 ? parseFloat(item[`valor_${i}_ponta`]) : null;
                                                        valores[`valor_${i}_geracao`] = parseFloat(item[`valor_${i}_geracao`]) > 0 ? parseFloat(item[`valor_${i}_geracao`]) : null;
                                                    }
                                                    const registro = {
                                                        ...item,
                                                        ...valores,
                                                        competencia_base_sazonalidade,
                                                    };
                                                    props.setModoTela("exclusao", registro);
                                                    props.initForm(registro);
                                                },
                                            }
                                        );
                                    } else {
                                        botoesDirectionRow = true; //deixa os botões em linha
                                        botoes.push(
                                            {
                                                style: { width: 38, height: 38, padding: 0 },
                                                type: "primary",
                                                text: <i className="fas fa-eye"></i>,
                                                disabled: !props.usuarioLogado.acesso_cadastro_demanda_visualizar,
                                                event: () => {
                                                    //cria a lista de valores valor_1 ..... valor_12 e adiciona ao registro
                                                    const valores = {};
                                                    for (let i = 1; i <= 12; i++) {
                                                        valores[`valor_${i}`] = parseFloat(item[`valor_${i}`]) > 0 ? parseFloat(item[`valor_${i}`]) : null;
                                                        valores[`valor_${i}_ponta`] = parseFloat(item[`valor_${i}_ponta`]) > 0 ? parseFloat(item[`valor_${i}_ponta`]) : null;
                                                        valores[`valor_${i}_geracao`] = parseFloat(item[`valor_${i}_geracao`]) > 0 ? parseFloat(item[`valor_${i}_geracao`]) : null;
                                                    }
                                                    const registro = {
                                                        ...item,
                                                        ...valores,
                                                        competencia_base_sazonalidade,
                                                    };
                                                    props.setModoTela("visualizacao", registro);
                                                    props.initForm(registro);
                                                },
                                            },
                                            {
                                                title: item.encerrado ? "success" : "danger",
                                                style: { width: 90, margin: 5, padding: "7px 0px" },
                                                text: <span style={{ fontSize: "0.8rem" }}>{item.encerrado ? "REABRIR" : "ENCERRAR"}</span>,
                                                type: item.encerrado ? "success" : "danger",
                                                disabled: !props.usuarioLogado.acesso_cadastro_demanda_editar || item.bloquearEdicaoUsuarioImplantacao,
                                                event: () => (item.encerrado ? props.reabrir(item) : props.encerrar(item)),
                                            }
                                        );
                                    }

                                    return (
                                        <NewTr key={item.id} backgroundColorTr={"#FFFFFF"} backgroundColorTd={"#F5F5F5"} botoes={botoes} botoesDirectionRow={botoesDirectionRow}>
                                            <Td>{`${props.listaMeses.filter((mes) => mes.id == item.mes_inicio)[0].valor} até ${
                                                props.listaMeses.filter((mes) => mes.id == item.mes_fim)[0].valor
                                            }`}</Td>
                                            <Td>{item.nome_cliente}</Td>
                                            <Td>{item.nome_unidade_consumidora}</Td>
                                            <Td>{item.sazonal ? "Sazonal" : "Não Sazonal"}</Td>
                                            <Td>
                                                {item.unidade_consumidora_sazonal == item.sazonal ? (
                                                    ""
                                                ) : (
                                                    <div
                                                        style={{
                                                            backgroundColor: "#fd5959",
                                                            color: "#ffffff",
                                                            padding: 5,
                                                            borderRadius: "0.3rem",
                                                            textAlign: "center",
                                                        }}
                                                    >
                                                        <div style={{ width: "100%", textWrap: "nowrap" }}>A sazonalidade da UC é diferente do contrato</div>
                                                        <div>
                                                            (UC:
                                                            {item.unidade_consumidora_sazonal ? " Sazonal " : " Não Sazonal "} - Contrato:
                                                            {item.sazonal ? " Sazonal " : " Não Sazonal "})
                                                        </div>
                                                    </div>
                                                )}
                                            </Td>
                                            <Td alignCenter minWidth={50}>
                                                {item.arquivo_cusd ? (
                                                    <ButtonTable
                                                        type={"primary"}
                                                        icon={"fas fa-file-pdf"}
                                                        visible={true}
                                                        disabled={!props.usuarioLogado.acesso_cadastro_demanda_visualizar}
                                                        event={() => {
                                                            props.buscaCusd(item.id, `CUSD_UC-${item.nome_unidade_consumidora.split("-")[0].trim()}`);
                                                            props.setArquivoPDF();
                                                        }}
                                                    />
                                                ) : null}
                                            </Td>
                                            <Td alignCenter minWidth={50}>
                                                {item.arquivo_ccer ? (
                                                    <ButtonTable
                                                        type={"primary"}
                                                        icon={"fas fa-file-pdf"}
                                                        visible={true}
                                                        disabled={!props.usuarioLogado.acesso_cadastro_demanda_visualizar}
                                                        event={() => {
                                                            props.buscaCcer(item.id, `CCER_UC-${item.nome_unidade_consumidora.split("-")[0].trim()}`);
                                                            props.setArquivoPDF();
                                                        }}
                                                    />
                                                ) : null}
                                            </Td>
                                            <Td alignCenter minWidth={50}>
                                                {item.arquivo_ciclo_rural ? (
                                                    <ButtonTable
                                                        type={"primary"}
                                                        icon={"fas fa-file-pdf"}
                                                        visible={true}
                                                        disabled={!props.usuarioLogado.acesso_cadastro_demanda_visualizar}
                                                        event={() => {
                                                            props.buscaCicloRural(item.id, `ciclo_rural_UC-${item.nome_unidade_consumidora.split("-")[0].trim()}`);
                                                            props.setArquivoPDF();
                                                        }}
                                                    />
                                                ) : null}
                                            </Td>
                                            <Td alignCenter minWidth={50} title="Histórico">
                                                <ButtonTable
                                                    type={"brown"}
                                                    icon={"fas fa-book"}
                                                    visible={true}
                                                    disabled={!item.historico.length}
                                                    event={() => {
                                                        setState({
                                                            ...state,
                                                            exibirModalHistorico: true,
                                                            itemSelecionado: item,
                                                        });
                                                    }}
                                                />
                                            </Td>
                                        </NewTr>
                                    );
                                })}
                        </TBody>
                    </Table>
                </ContentCardBody>
            </ContentCard>
        );
    }

    function importarContrato() {
        return (
            <ContentCard>
                <ContentCardBody>
                    <div className="form-group">
                        <div className="custom-file">
                            <input
                                className="custom-file-input"
                                type="file"
                                id="customFile"
                                value={state.file}
                                onChange={(event) => {
                                    event.preventDefault();
                                    let reader = new FileReader();
                                    let file = event.target.files[0];

                                    // if (!file.type.includes('application/pdf')) {
                                    // 	//toastr.error('Erro', 'Selecione apenas PDF.');
                                    // 	return;
                                    // }

                                    reader.onloadend = () => {
                                        props.importarContrato(props.formularioValues, reader.result);
                                    };

                                    reader.readAsDataURL(file);
                                }}
                            />
                            <label className="custom-file-label" for="customFile">
                                Selecione
                            </label>
                        </div>
                    </div>
                </ContentCardBody>
                <ContentCardFooter>
                    <Row alignCenter>
                        <Grid cols="6 6 4 3">
                            <Button text="Voltar" type={"warning"} icon={"fa fa-chevron-left"} event={() => props.setModoTela("cadastro")} />
                        </Grid>
                    </Row>
                </ContentCardFooter>
            </ContentCard>
        );
    }

    function importarCusd() {
        return (
            <ContentCard>
                <ContentCardBody>
                    <div className="form-group">
                        <Select
                            name="descricao"
                            options={[
                                { id: "Contrato de Implantação - Primeiro Contrato Cadastrado", valor: "Contrato de Implantação - Primeiro Contrato Cadastrado" },
                                { id: "Aumento de Demanda", valor: "Aumento de Demanda" },
                                { id: "Redução de Demanda", valor: "Redução de Demanda" },
                                { id: "Alteração de opção tarifária para grupo A", valor: "Alteração de opção tarifária para grupo A" },
                                {
                                    id: "Ajuste de demanda (aumento e redução no mesmo)",
                                    valor: "Ajuste de demanda (aumento e redução no mesmo)",
                                },
                                { id: "Passou a ser sazonal", valor: "Passou a ser sazonal" },
                                { id: "Passou a ser não sazonal", valor: "Passou a ser não sazonal" },
                                {
                                    id: "Adicionar contrato com versão final assinado. (Está em andamento a alteração, e tinha um contrato que ainda faltava assinatura por parte da distribuidora)",
                                    valor: "Adicionar contrato com versão final assinado. (Está em andamento a alteração, e tinha um contrato que ainda faltava assinatura por parte da distribuidora)",
                                },
                                {
                                    id: "Correção de cadastro errado (sem alteração na concessionária, apenas estava com informação errada)",
                                    valor: "Correção de cadastro errado (sem alteração na concessionária, apenas estava com informação errada)",
                                },
                            ]}
                            label="Motivo"
                            cols="12 6 6 6"
                            placeholder="Selecione o motivo"
                            isClearable={false}
                            isSearchable={false}
                            value={state.descricao}
                            onChange={(value) => {
                                setState({
                                    ...state,
                                    descricao: value,
                                });
                            }}
                        />
                        <label className="ml-2 mt-3">Arquivo</label>
                        <div className="col-sm-12 col-md-6">
                            <div className="custom-file">
                                <input
                                    className="custom-file-input"
                                    type="file"
                                    id="customFile"
                                    onChange={(event) => {
                                        event.preventDefault();
                                        let reader = new FileReader();
                                        let file = event.target.files[0];

                                        reader.onloadend = () => {
                                            setState({
                                                ...state,
                                                file: file.name || "Selecione um arquivo",
                                                arquivo_cusd: reader.result,
                                            });
                                        };

                                        reader.readAsDataURL(file);
                                    }}
                                />
                                <label className="custom-file-label" for="customFile">
                                    {state.file || "Selecione um arquivo"}
                                </label>
                            </div>
                        </div>
                    </div>
                </ContentCardBody>
                <ContentCardFooter>
                    <Row alignCenter>
                        <Grid cols="6 6 4 3">
                            <Button
                                text="Salvar"
                                type={"success"}
                                icon={"fa fa-check"}
                                event={() => {
                                    props.importarCusd({
                                        ...props.formularioValues,
                                        descricao: state.descricao,
                                        arquivo_cusd: state.arquivo_cusd,
                                    });
                                    setState({ ...state, descricao: null, file: null, arquivo_cusd: null });
                                }}
                            />
                        </Grid>
                        <Grid cols="6 6 4 3">
                            <Button
                                text="Voltar"
                                type={"warning"}
                                icon={"fa fa-chevron-left"}
                                event={() => {
                                    setState({ ...state, descricao: null, file: null, arquivo_cusd: null });
                                    props.setModoTela("cadastro", props.formularioValues);
                                }}
                            />
                        </Grid>
                    </Row>
                </ContentCardFooter>
            </ContentCard>
        );
    }

    function importarCcer() {
        return (
            <ContentCard>
                <ContentCardBody>
                    <div className="form-group">
                        <div className="custom-file">
                            <input
                                className="custom-file-input"
                                type="file"
                                id="customFile"
                                value={state.file}
                                onChange={(event) => {
                                    event.preventDefault();
                                    let reader = new FileReader();
                                    let file = event.target.files[0];

                                    // if (!file.type.includes('application/pdf')) {
                                    // 	//toastr.error('Erro', 'Selecione apenas PDF.');
                                    // 	return;
                                    // }

                                    reader.onloadend = () => {
                                        props.importarCcer(props.formularioValues, reader.result);
                                    };

                                    reader.readAsDataURL(file);
                                }}
                            />
                            <label className="custom-file-label" for="customFile">
                                Selecione
                            </label>
                        </div>
                    </div>
                </ContentCardBody>
                <ContentCardFooter>
                    <Row alignCenter>
                        <Grid cols="6 6 4 3">
                            <Button text="Voltar" type={"warning"} icon={"fa fa-chevron-left"} event={() => props.setModoTela("cadastro")} />
                        </Grid>
                    </Row>
                </ContentCardFooter>
            </ContentCard>
        );
    }

    function importarCicloRural() {
        return (
            <ContentCard>
                <ContentCardBody>
                    <div className="form-group">
                        <div className="custom-file">
                            <input
                                className="custom-file-input"
                                type="file"
                                id="customFile"
                                value={state.file}
                                onChange={(event) => {
                                    event.preventDefault();
                                    let reader = new FileReader();
                                    let file = event.target.files[0];

                                    // if (!file.type.includes('application/pdf')) {
                                    // 	//toastr.error('Erro', 'Selecione apenas PDF.');
                                    // 	return;
                                    // }

                                    reader.onloadend = () => {
                                        props.importarCicloRural(props.formularioValues, reader.result);
                                    };

                                    reader.readAsDataURL(file);
                                }}
                            />
                            <label className="custom-file-label" for="customFile">
                                Selecione
                            </label>
                        </div>
                    </div>
                </ContentCardBody>
                <ContentCardFooter>
                    <Row alignCenter>
                        <Grid cols="6 6 4 3">
                            <Button text="Voltar" type={"warning"} icon={"fa fa-chevron-left"} event={() => props.setModoTela("cadastro")} />
                        </Grid>
                    </Row>
                </ContentCardFooter>
            </ContentCard>
        );
    }
}

const mapStateToProps = (state) => ({
    sessao: state.auth.usuario,
    usuarioLogado: state.auth.usuarioLogado,
    modoTela: state.demandaContrato.modoTela,
    formularioValues: getFormValues("demandaContratoForm")(state),
    aguardando: state.demandaContrato.aguardando,
    filtro: state.demandaContrato.filtro,
    lista: state.demandaContrato.lista,
    listaCliente: state.demandaContrato.listaCliente,
    listaUnidadeConsumidora: state.demandaContrato.listaUnidadeConsumidora,
    listaMeses: state.demandaContrato.listaMeses,
    pdf: state.displayPDF.pdf,
    nomePdf: state.displayPDF.nomePdf,
});
const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            setModoTela,
            initForm,
            setFiltro,
            salvar,
            excluir,
            salvarAgendamento,
            excluirAgendamento,
            importarContrato,
            importarCusd,
            importarCcer,
            importarCicloRural,
            getLista,
            getListaCliente,
            getListaUnidadeConsumidora,
            getListaDemandaContratoTipo,
            buscaContrato,
            buscaCusd,
            buscaCcer,
            buscaCicloRural,
            setArquivoPDF,
            encerrar,
            reabrir,
        },
        dispatch
    );
export default connect(mapStateToProps, mapDispatchToProps)(DemandaContrato);
